import { render, staticRenderFns } from "./PopupPhuAssign.vue?vue&type=template&id=4a465139&scoped=true"
import script from "./PopupPhuAssign.vue?vue&type=script&lang=js"
export * from "./PopupPhuAssign.vue?vue&type=script&lang=js"
import style0 from "./PopupPhuAssign.vue?vue&type=style&index=0&id=4a465139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a465139",
  null
  
)

export default component.exports